import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SidebarState {
  isCollapsed: boolean
  activeModuleId: string | null
  toggleCollapsed: () => void
  setCollapsed: (collapsed: boolean) => void
  setActiveModule: (moduleId: string | null) => void
}

/**
 * Sidebar state — persists collapsed state across sessions.
 * Active module is set on navigation, not persisted (route is the source of truth).
 */
export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      isCollapsed: false,
      activeModuleId: null,

      toggleCollapsed: () =>
        set((state) => ({ isCollapsed: !state.isCollapsed })),

      setCollapsed: (collapsed) =>
        set({ isCollapsed: collapsed }),

      setActiveModule: (moduleId) =>
        set({ activeModuleId: moduleId }),
    }),
    {
      name: 'nttd-sidebar',
      partialize: (state) => ({ isCollapsed: state.isCollapsed }), // Only persist collapse state
    }
  )
)
